import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WeekPickerComponent } from './week-picker/week-picker.component';
import { MonthPickerComponent } from './month-picker/month-picker.component';
import { YearPickerComponent } from './year-picker/year-picker.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { ReactiveFormsModule } from '@angular/forms';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { DayPickerComponent } from './day-picker/day-picker.component';
import { AtomsModule } from '@library/ui/atoms/atoms.module'
import { CustomDateAdapter } from '@library/ui/organisms/measures-date-pickers/custom-date-adapter.service';
import { DateAdapter } from '@angular/material/core';


@NgModule({
  declarations: [
    WeekPickerComponent,
    MonthPickerComponent,
    YearPickerComponent,
    DayPickerComponent,
  ],
  exports: [
    WeekPickerComponent,
    MonthPickerComponent,
    YearPickerComponent,
    DayPickerComponent,
  ],
  imports: [
    CommonModule,
    MatDatepickerModule,
    ReactiveFormsModule,
    MatMomentDateModule,
    AtomsModule,
  ],
  providers: [
    {
      provide: DateAdapter,
      useClass: CustomDateAdapter,
    }
  ]
})
export class MeasuresDatePickersModule { }
